import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { parseQueryString, QueryParameters } from '@moda/portal-stanchions';

const STORE_KEY = 'sessionQueryParams';

export const useSessionQueryParams = () => {
  const location = useLocation();
  const params: QueryParameters =
    typeof sessionStorage !== 'undefined'
      ? JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}')
      : {};

  useEffect(() => {
    const queryParams = parseQueryString(location.search);
    const storedParams: QueryParameters = JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}');
    sessionStorage.setItem(STORE_KEY, JSON.stringify({ ...storedParams, ...queryParams }));
  }, [location.search]);

  return params;
};
